import { FC, useContext } from "react";
import styles from './index.module.scss';
import Image from "next/image";
import { OpenType } from "@/constants";
import { StoreContext, namespace } from '@/context';

export interface FunctionItem {
  link: string;
  icon: string;
  title: string;
  openType?: OpenType;
}

export interface MoreFuctionsProps {
  title: string;
  data: FunctionItem[]
}

// 更多功能卡片
const MoreFuctions: FC<MoreFuctionsProps> = ({
  title,
  data = [],
}) => {
  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS } = state[namespace.app].sensors || {};
  const { pcActiveChannelName } = state[namespace.home];

  const handleTrackCb = (title: string, link: string) => {
    track?.(TRACK_EVENTS?.[namespace.home].serviceMore.name, {
      list_name: pcActiveChannelName,
      button_name: title,
      url: link,
      position: 'MoreFeatures',
    }, namespace.home);
  }

  return (
    <div className={styles.moreFunctions}>
      <div  className={styles.title}>{title}</div>
      <ul className={styles.functionList}>
        {data.map(item => (
          <li
            key={item.title}
            className={styles.functionItem}
            onClick={() => {
              if (item.link) {
                handleTrackCb(item.title, item.link);
                window.open(item.link, (item.openType && item.openType === OpenType.NewWindow) ? '_blank' : '_self');
              }
            }}
          >
            <Image
              width={40}
              height={40}
              alt="logo"
              src={item.icon}
              className={styles.icon}
              loader={({ src }) => src}
            />
            <div className={styles.text}>{item.title}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MoreFuctions;
